import { useEffect, useState, useRef } from "react";
import EmployeePermissionService from "../services/EmployeePermissionService";
import UserService from "../services/EmployeeService";
import StorageService from "../services/StorageService";
import Breadcrumb from "../components/Breadcrumb";

export default function UnAuthorized() {

  return (
    <>
      <Breadcrumb pageTitle="Employee Permission" secondTitle="UnAuthorized" />

     
      <div className="card shadow-sm">
        <div className="card-header">
          <h5 className="text-info">Employee Permission</h5>
        </div>

        <div className="card-body position-relative">

        You don't have permission. Please contact adminstrtor.

        </div>
      </div>
    </>
  );
}